import {
  AddShoppingCart,
  ConstructionRounded,
  ChatRounded,
} from '@mui/icons-material'
import { TAppealInList, TAppealType } from 'feature/appeals/type'
import { ReactElement } from 'react'

type OrderTypeInfo = {
  icon: ReactElement
  label: string
}
// иконки карточки заявки по типу
export const getIconByAppealType: Record<TAppealType, ReactElement> = {
  ORDERING: <AddShoppingCart />,
  SERVICE: <ConstructionRounded />,
  CONSULTATION: <ChatRounded />,
}

// получение данных карточки заявки по типу
export function useAppealCardDate(appeal: TAppealInList): OrderTypeInfo {
  const { subType, type, typeName } = appeal
  const appealTypeName = subType ? subType : typeName

  return { icon: getIconByAppealType[type], label: appealTypeName }
}
